import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Admission() { 
  useEffect(() => {
    document.title = 'Documents Required-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li> 
                <li>Admission</li>
                <li>Documents Required</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Documents Required</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12"> 
                 <h5>Documents Required for admissions:</h5> 
                    <p>While coming to submit the registration form the following documents to be submitted without fail.</p>
                       <ul className="mainlist">
                        <li> Birth certificate of your child with name written on it. ( Copy and original ) </li>
                        <li> Adhaar card with name written on it.  ( Copy and original ) </li>
                        <li> Parents adhaar card. (Copy self attested by both the parents ) </li>
                        <li> Family ID </li>
                        <li> 5*3 size photograph child with parents. </li>
                        <li> 3 passport size photographs of the child. </li>
                        <li> Presence of both the parents compulsory while filling the admission form as the signature of both the parents required. </li>
                        <li> Transfer certificate and report card of your ward from the school where they are coming. ( By the 20th of April) after that only admission confirmed. </li>
                    </ul> 
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Admission;
